/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


app.service('NetworkService', ["$rootScope", "$http", 'AtlasNotification', '$timeout', function($rootScope, $http, AtlasNotification, $timeout) {

    var _createRequest = function(command, data) {
        fields = data
        fields["command"] = command

        return fields;
    }

    var allowedOfflineCommands = ["getNotifications",
        "getHighestPermission",
        "registerMonitor",
        "unRegisterMonitor",
        "getMonitorData"
    ];

    var _send = function(data, callback) {
        
        var req3 = {
            method: 'POST',
            url: "Api/hosiapi.php",
            data: $.param(data),
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        }
        //$rootScope.$emit("startLoad");
        $http(req3).then(function(data) {
            $rootScope.$emit("endLoad");
            if (data.data.done === false) {
                if (data.data.error == "20") {
                    var command = data.data.command
                    if (allowedOfflineCommands.indexOf(command) == -1) {
                        //alert(command)
                        window.location.replace("./index.php");
                    }

                }
            }
            if (callback != undefined) {
                callback(data.data)
            }
        }, "json");
    }

    var setLoginToken = function(email, callback) {
        var data = { email: email }
        _event("maximizeEvent", data, callback)
    }

    /**
     *
     * @param {type} email
     * @param {type} callback
     * @returns {undefined}
     * Loggs the user in
     */
    var checkLoginToken = function(email, token, callback) {
        var data = { email: email, token: token }
        _event("checkLoginToken", data, callback)
    }


    var sendMassEmail = function(position_id, userArray, templatename, callback) {
        var data = { position_id: position_id, user_array: userArray, template_name: templatename }
        _event("sendMassEmail", data, callback)
    }
    var checkCaptcha = function(captcha, callback) {
        var data = { captcha: captcha }
        _event("checkCaptcha", data, callback)
    }

    var deleteMe = function(email, callback) {
        var data = { email: email }
        _event("deleteMe", data, callback)
    }

    var maximizeEvent = function(event_id, callback) {
        var data = { event_id: event_id }
        _event("maximizeEvent", data, callback)
    }

    var minimizeEvent = function(event_id, callback) {
        var data = { event_id: event_id }
        _event("minimizeEvent", data, callback)
    }

    var getMyLevelAndPoints = function(callback) {
        var data = {}
        _event("getMyLevelAndPoints", data, callback)
    }

    var archiveEvent = function(event_id, callback) {
        var data = { event_id: event_id }
        _event("archiveEvent", data, callback)
    }

    var getLoggedInCount = function(email, callback) {
        var data = { email: email }
        _event("getLoggedInCount", data, callback)
    }

    var raiseLoggedInCounter = function(email, callback) {
        var data = { email: email }
        _event("raiseLoggedInCounter", data, callback)
    }
    var unArchiveEvent = function(event_id, callback) {
        var data = { event_id: event_id }
        _event("unArchiveEvent", data, callback)
    }

    var getGastLink = function(event_id, callback) {
        var data = { event_id: event_id }
        _event("getGastLink", data, callback)
    }
    var getGroupsForUser = function(email, callback) {
        var data = { email: email }
        _event("getGroupsForUser", data, callback)
    }
    var getArchivedEvents = function(callback) {
        var data = {}
        _event("getArchivedEvents", data, callback)
    }

    var declineUserSchicht = function(email, schicht_id, position_id, memo, callback) {
        var fields = {}
        fields.email = email
        fields.schicht_id = schicht_id
        fields.position_id = position_id
        fields.memo = memo
        _event("declineUserSchicht", fields, callback)
    }

    var getPassportDetails = function(email, location, callback) {
        data = { email: email, location: location }
        _event("getPassportDetails", data, callback)
    }

    var getParticipatedShifts = function(email, callback) {
        data = { email: email }
        _event("getParticipatedShifts", data, callback)
    }
    var declineAdminSchicht = function(email, schicht_id, position_id, callback) {
        fields = {}
        fields.email = email
        fields.schicht_id = schicht_id
        fields.position_id = position_id
        _event("declineAdminSchicht", fields, callback)
    }

    var handleServerError = function(response) {
        try {
            if (response.data.exception[0].type == "Atlas\\Core\\Exceptions\\ApplicationException") {
                AtlasNotification.error("Ein Fehler ist aufgetreten: " + response.data.exception[0].message);
            }
            else {
                AtlasNotification.error("Ein unerwarteter Fehler ist aufgetreten");
            }

        }
        catch (e) {
            AtlasNotification.error("Ein unerwarteter Fehler ist aufgetreten");
            console.error(response)
        }
        console.error(response)
    }

    var _sendToOperationWithCaptcha = function(operation, data, callback, token){
        data._pt = {};
        data._pt.securtiy = {};
        data._pt.securtiy.token = token;
        var req = {
            method: 'POST',
            url: "/" + operation,
            data: $.param(data),
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        }
        var _self = this;
        $rootScope.$emit("startLoad");
        $http(req).then(function(data) {
            $rootScope.$emit("endLoad");
            var response = new Response(data.data);
            if (data.data.done === false) {
                if (data.data.error == "20") {
                    var command = data.data.command
                    if (allowedOfflineCommands.indexOf(command) == -1) {
                        window.location.replace("/");
                    }
                }
            }
            if (callback != undefined) {
                callback(response)
            }
        }, function(response) {
            handleServerError(response);
        }, "json")
    }
    
    var _sendToOperation = function(operation, data, callback) {

         if(typeof grecaptcha != "undefined"){
             if(typeof grecaptcha.execute == 'undefined'){
                grecaptcha.ready(function() {
                    grecaptcha.execute(CAPTCHA_PUBLIC_KEY, {action: 'operation'+operation}).then(function(token) {
                        _sendToOperationWithCaptcha(operation, data, callback, token);
                    });
                });
             }else{
                 grecaptcha.execute(CAPTCHA_PUBLIC_KEY, {action: 'operation'+operation}).then(function(token) {
                        _sendToOperationWithCaptcha(operation, data, callback, token);
                });
             }
        }else{
        var req = {
            method: 'POST',
            url: "/" + operation,
            data: $.param(data),
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        }
        var _self = this;
        $rootScope.$emit("startLoad");
        $http(req).then(function(data) {
            $rootScope.$emit("endLoad");
            var response = new Response(data.data);
            if (data.data.done === false) {
                if (data.data.error == "20") {
                    var command = data.data.command
                    if (allowedOfflineCommands.indexOf(command) == -1) {
                        window.location.replace("/");
                    }
                }
            }
            if (callback != undefined) {
                callback(response)
            }
        }, function(response) {
            handleServerError(response);
        }, "json")
    }
    }
    
    var _event = function(command, data, callback) {
        var req = _createRequest(command, data)

        _send(req, callback)
    }

    var addNotification = function(email, text) {
        fields = {}
        fields.email = email
        fields.text = text
        _event("addNotification", fields)
    }

    var login = function(email, password, captchaKey, callback) {
        fields = {}
        fields.password = password
        fields.email = email
        fields.captchaKey = captchaKey
        _event("login", fields, callback)
    }

    var userHasSeenNotifications = function(email) {

        data = { email: email }
        _event("userHasSeenNotifications", data)
    }
    var getNotifications = function(email, callback) {
        data = { email: email }
        _event("getNotifications", data, callback)
    }

    var getCalendarForShiftManager = function(event_id, callback) {
        data = { event_id: event_id }
        _event("getCalendarForShiftManager", data, callback)

    }

    var getStatistics = function(event_id, callback) {
        data = { event_id: event_id }
        _event("getStatistics", data, callback)
    }
    var getCalendar = function(event_id, callback) {
        data = { event_id: event_id }
        _event("getCalendar", data, callback)

    }

    var updateEmail = function(oldEmail, newEmail, callback) {
        var data = {
            old_email: oldEmail,
            new_email: newEmail
        }
        _event("updateEmail", data, callback)
    }

    var updatePublishState = function(even_id, newState) {
        data = {
            event_id: even_id,
            new_state: newState
        }
        _event("updatePublishState", data)
    }

    var addNote = function(user, note) {
        var data = { email: user, note: note, type: 0 }
        var req = _createRequest("addNote", data)
        _send(req)

    };

    var updateUser = function(data, callback) {
        _event("updateUser", data, callback)
    }

    var getPartner = function(email, position_id, schicht_id, callback) {
        var data = { email: email, schicht_id: schicht_id, position_id: position_id }
        _event("getPartner", data, callback)
    }

    var getAllSpecialFields = function(callback) {
        var data = {}
        _event("getAllSpecialFields", data, callback)
    }

    var updateSchicht = function(data, callback) {
        _event("updateSchicht", data, callback)
    }

    var updateArbeit = function(schicht_id, position_id, email, essen, tshirt, eingesetzt_als, callback) {
        var data = {
            schicht_id: schicht_id,
            position_id: position_id,
            email: email,
            eingesetzt_als: eingesetzt_als,
            essen: essen,
            tshirt: tshirt
        }
        _event("updateArbeit", data, callback)
    }

    var getArbeit = function(schicht_id, position_id, email, callback) {
        var data = {
            schicht_id: schicht_id,
            position_id: position_id,
            email: email
        }
        _event("getArbeit", data, callback)
    }
    var updateEvent = function(data, callback) {
        _event("updateEvent", data, callback)
    }

    var uploadProfilePic = function(img, email, callback) {
        data = {
            profilePic: img,
            email: email
        }
        _event("uploadProfilePic", data, callback)
    }

    var addUser = function(data, callback) {
        _event("addUser", data, callback)
    }

    var getMonitorData = function(monitor, key, checksumm, callback) {
        data = { monitor: monitor, key: key, checksumm: checksumm }
        _event("getMonitorData", data, callback)
    }


    var registerMonitor = function(monitor, key, callback) {

        data = { monitor: monitor, key: key }
        _event("registerMonitor", data, callback)
    }

    var unRegisterMonitor = function(monitor, key, callback) {
        data = { monitor: monitor, key: key }
        _event("unRegisterMonitor", data, callback)
    }

    var addUserToSchicht = function(position_id, schicht_id, email, essen, tshirt, callback) {
        data = {
            position_id: position_id,
            schicht_id: schicht_id,
            email: email,
            essen: essen,
            tshirt: tshirt
        }
        _event("addUserToSchicht", data, callback)
    }

    var blockUser = function(email, callback) {
        data = { email: email }
        _event("blockUser", data, callback)
    }

    var getNotes = function(user, callback) {
        data = { email: user }
        req = _createRequest("getNotes", data)
        _send(req, callback)
    }

    var getEventsForUser = function(email, callback) {
        data = { email: email }
        req = _createRequest("getEventsForUser", data)
        _send(req, callback)
    }

    var getEventsForEmail = function(email, callback) {
        data = { email: email }
        req = _createRequest("getEventsForEmail", data)
        _send(req, callback)
    }

    var getEvents = function(callback) {
        data = {}
        _event("getEvents", data, callback)
    }

    var borrowDonationBox = function(boxId, SchichtId, PositionId, Email, callback) {
        var data = { boxId: boxId, schichtId: SchichtId, positionId: PositionId, email: Email }
        _event("borrowDonationBox", data, callback)
    }

    var returnDonationBox = function(boxId, SchichtId, PositionId, Email, callback) {
        var data = { boxId: boxId, schichtId: SchichtId, positionId: PositionId, email: Email }
        _event("returnDonationBox", data, callback)
    }

    var presenceStatusChanged = function(state, SchichtId, PositionId, Email, callback) {
        var data = { state: state, schichtId: SchichtId, positionId: PositionId, email: Email }
        _event("presenceStatusChanged", data, callback)
    }
    var getMitarbeiterForEventDetailed = function(event_id, callback) {
        var data = { event: event_id }
        _event("getMitarbeiterForEvent", data, callback)
    }

    var getMitarbeiterForEvent = function(event_id, callback) {
        var data = { event: event_id }
        _event("getMitarbeiter", data, callback)
    }

    var getMitarbeiter = function(callback) {
        var data = {}
        _event("getMitarbeiter", data, callback)
    }

    var getMitarbeiterNames = function(callback) {
        var data = {}
        _event("getMitarbeiterNames", data, callback)
    }

    var acceptUserSchicht = function(email, schicht_id, position_id, eingesetzt_als, callback) {
        var data = { schicht_id: schicht_id, position_id: position_id, email: email, eingesetzt_als: eingesetzt_als }
        _event("acceptUserSchicht", data, callback)
    }

    var acceptAdminSchicht = function(email, schicht_id, position_id, essen, tshirt, callback) {
        var data = { schicht_id: schicht_id, position_id: position_id, email: email, essen: essen, tshirt: tshirt }
        _event("acceptAdminSchicht", data, callback)
    }

    var resendApproveEmail = function(email, callback) {
        var data = { email: email }
        _event("resendApproveEmail", data, callback)
    }

    var removeEvent = function(event_id, callback) {
        var data = { event_id: event_id, }
        _event("removeEvent", data, callback)
    }

    var removePosition = function(position_id, callback) {
        var data = { position_id: position_id }
        _event("removePosition", data, callback)
    }

    var removeUserFromSchicht = function(schicht_id, position_id, email, callback) {
        data = {
            schicht_id: schicht_id,
            position_id: position_id,
            email: email
        }
        _event("removeUserFromSchicht", data, callback)
    }


    var updatePermission = function(permission, group, callback) {
        var data = permission;
        data.groupId = group;
        _event("updatePermission", data, callback)
    }
    var addPermission = function(groupId, eventName, permission, callback) {
        var data = {
            event_id: eventName,
            permission: permission,
            group_id: groupId
        }
        _event("addPermission", data, callback)
    }

    var removePermission = function(data, callback) {
        _event("removePermission", data, callback)
    }

    var getSpecialFields = function(position_id, callback) {
        var data = { position_id: position_id }
        _event("getSpecialFields", data, callback)
    }

    var getGroups = function(callback) {
        data = {}
        _event("getGroups", data, callback)
    }

    var searchPartner = function(firstName, secondName, callback) {
        var data = {
            first_name: firstName,
            second_name: secondName
        }
        _event("searchPartner", data, callback)
    }
    var getPermissions = function(groupId, callback) {
        data = { group_id: groupId }
        _event("getPermissions", data, callback)
    }

    var updateTemplate = function(data, callback) {
        _event("updateTemplate", data, callback)
    }
    var getGroupMembers = function(groupId, callback) {
        data = { group_id: groupId }
        _event("getGroupMembers", data, callback)
    }

    var getTemplates = function(callback) {
        var data = {}
        _event("getTemplates", data, callback)
    }
    var getPermissionForEvent = function(eventId, callback) {
        var data = {
            event_id: eventId
        }
        _event("getPermissionForEvent", data, callback)
    }

    var updatePosition = function(data, callback) {
        _event("updatePosition", data, callback)
    }

    var addPositionToSchicht = function(schicht_id, position_id, menge, callback) {
        var data = {
            position_id: position_id,
            schicht_id: schicht_id,
            menge: menge
        }
        _event("addPositionToSchicht", data, callback)
    }

    var removeTemplate = function(template, callback) {
        var data = { template: template }
        _event("removeTemplate", data, callback)
    }

    var addTemplate = function(templatename, templatetext, callback) {
        var data = {
            templateName: templatename,
            templateText: templatetext
        }
        _event("addTemplate", data, callback)
    }

    var removeGroup = function(data, callback) {
        _event("removeGroup", data, callback)
    }
    var addGroup = function(groupname, groupdescr, callback) {
        var data = {
            groupName: groupname,
            groupDescr: groupdescr
        }
        _event("addGroup", data, callback)
    }

    var addPersonToGroup = function(email, id, callback) {
        data = {
            email: email,
            groupId: id
        }
        _event("addPersonToGroup", data, callback)
    }

    var callOperation = function(operation, data, callback) {
        _sendToOperation(operation, data, callback)
    }

    var addEvent = function(name, ort, adresse, from, to, email, img, callback) {
        var data = {
            eventname: name,
            veranstaltungsort: ort,
            veranstaltungsadresse: adresse,
            start: from,
            ende: to,
            email: email,
            img: img
        }
        _event("addEvent", data, callback)
    }

    var addEvent = function(name, ort, adresse, from, to, email, img, callback) {
        var data = {
            eventname: name,
            veranstaltungsort: ort,
            veranstaltungsadresse: adresse,
            start: from,
            ende: to,
            email: email,
            img: img
        }
        _event("addEvent", data, callback)
    }


    var updateGroupMembers = function(members, group_id, callback) {
        var data = {
            members: members,
            group_id: group_id
        }
        _event("updateGroupMembers", data, callback)
    }

    var updatePermissionsForPosition = function(groups, position_id, event_id, callback) {
        var data = {
            groups: groups,
            position_id: position_id,
            event_id: event_id
        }
        _event("updatePermissionsForPosition", data, callback)
    }

    var updatePassword = function(data, callback) {
        _event("updatePassword", data, callback)
    }
    var getHistory = function(email, callback) {
        var data = { email: email }
        _event("getHistory", data, callback)
    }

    var sendPasswordResetEmail = function(email, callback) {
        var data = { email: email }
        _event("sendPasswordResetEmail", data, callback)
    }

    var resetPassword = function(email, token, newPassword, callback) {
        var data = { email: email, token: token, new_password: newPassword }
        _event("resetPassword", data, callback)
    }
    var moveUser = function(data, callback) {
        _event("moveUser", data, callback)
    }

    var getEventDetails = function(event_id, callback) {
        var data = { event_id: event_id }
        _event("getEventDetails", data, callback)
    }
    var getHighestPermission = function(callback) {
        var data = {}
        _event("getHighestPermission", data, callback)
    }

    var removeSchicht = function(data, callback) {
        _event("removeSchicht", data, callback)
    }

    var generateEmailList = function(position_id, event_id, callback) {
        var data = { position_id: position_id, event_id: event_id }
        _event("getCsv", data, callback)
    }
    var addSchichtToEvent = function(data, callback) {
        _event("addSchicht", data, callback)
    }

    var addLeading = function(email, position_id, schicht_id, isLeading, callback) {
        var data = {
            position_id: position_id,
            schicht_id: schicht_id,
            is_leading: isLeading,
            email: email
        }
        _event("addLeading", data, callback)
    }

    var registerPairField = function(position_id, schicht_id, firstName, secondName, email, callback) {
        var data = {
            position_id: position_id,
            schicht_id: schicht_id,
            first_name: firstName,
            second_name: secondName,
            email: email
        }
        _event("registerPairField", data, callback)
    }

    var getPermissionForPosition = function(position_id, callback) {
        var data = { position_id: position_id }
        _event("getPermissionForPosition", data, callback)
    }

    var getPositionenForEvent = function(event_id, callback) {
        var data = { event_id: event_id }
        _event("getPositionenForEvent", data, callback)
    }

    var getEmailAdresses = function(event_id, position_id, callback) {
        var data = {
            event_id: event_id,
            position_id: position_id
        }
        _event("getEmailAdresses", data, callback)
    }
    var getEingesetztAls = function(callback) {
        var data = {}
        _event("getEingesetztAls", data, callback)
    }

    var updatePartner = function(data, callback) {
        _event("updatePartner", data, callback)
    }

    var getGroupsForEvent = function(event_id, callback) {
        var data = { event_id: event_id }
        _event("getGroupsForEvent", data, callback)
    }

    var getMitarbeiterDetails = function(email, callback) {
        var data = { email: email }
        _event("getMitarbeiterDetails", data, callback)
    }

    var getFoodForEvent = function(event_id, callback) {
        var data = { event_id: event_id }
        _event("getFoodForEvent", data, callback)
    }

    var updateFoodInEvent = function(event_id, food, callback) {
        var data = {
            event_id: event_id,
            food: food
        }
        _event("updateFoodInEvent", data, callback)
    }

    var addPosition = function(text, descr, event_id, picture, positionAdminApproval, isPairPosition, isLeadingOrFollowingPosition, hasTshirt, callback) {
        var data = {
            text: text,
            descr: descr,
            picture: picture,
            positionAdminApproval: positionAdminApproval,
            isPairPosition: isPairPosition,
            event_id: event_id,
            isLeadingOrFollowingPosition: isLeadingOrFollowingPosition,
            hasTshirt: hasTshirt
        }

        if (event_id !== undefined) {
            data.event_id = event_id
        }

        _event("addPosition", data, callback)
    }

    return {
        addNote: addNote,
        addUser: addUser,
        addUserToSchicht: addUserToSchicht,
        addPosition: addPosition,
        getNotes: getNotes,
        addNotification: addNotification,
        declineUserSchicht: declineUserSchicht,
        declineAdminSchicht: declineAdminSchicht,
        getNotifications: getNotifications,
        userHasSeenNotifications: userHasSeenNotifications,
        login: login,
        updatePublishState: updatePublishState,
        updateEvent: updateEvent,
        updateUser: updateUser,
        uploadProfilePic: uploadProfilePic,
        getCalendar: getCalendar,
        blockUser: blockUser,
        getEventsForUser: getEventsForUser,
        acceptAdminSchicht: acceptAdminSchicht,
        acceptUserSchicht: acceptUserSchicht,
        removeUserFromSchicht: removeUserFromSchicht,
        getGroups: getGroups,
        getMitarbeiterNames: getMitarbeiterNames,
        addGroup: addGroup,
        addPersonToGroup: addPersonToGroup,
        getGroupMembers: getGroupMembers,
        getPermissions: getPermissions,
        getEvents: getEvents,
        getEventsForEmail: getEventsForEmail,
        addPermission: addPermission,
        removePermission: removePermission,
        updatePermission: updatePermission,
        addEvent: addEvent,
        addTemplate: addTemplate,
        getTemplates: getTemplates,
        getPermissionForEvent: getPermissionForEvent,
        moveUser: moveUser,
        getHistory: getHistory,
        removeEvent: removeEvent,
        updateTemplate: updateTemplate,
        addPositionToSchicht: addPositionToSchicht,
        addSchichtToEvent: addSchichtToEvent,
        updatePosition: updatePosition,
        updateSchicht: updateSchicht,
        getSpecialFields: getSpecialFields,
        getHighestPermission: getHighestPermission,
        updateGroupMembers: updateGroupMembers,
        removeTemplate: removeTemplate,
        removeGroup: removeGroup,
        getEventDetails: getEventDetails,
        removeSchicht: removeSchicht,
        getCalendarForShiftManager: getCalendarForShiftManager,
        getParticipatedShifts: getParticipatedShifts,
        getFoodForEvent: getFoodForEvent,
        searchPartner: searchPartner,
        registerPairField: registerPairField,
        addLeading: addLeading,
        updateFoodInEvent: updateFoodInEvent,
        archiveEvent: archiveEvent,
        unArchiveEvent: unArchiveEvent,
        getArchivedEvents: getArchivedEvents,
        getLoggedInCount: getLoggedInCount,
        raiseLoggedInCounter: raiseLoggedInCounter,
        getPermissionForPosition: getPermissionForPosition,
        updatePermissionsForPosition: updatePermissionsForPosition,
        minimizeEvent: minimizeEvent,
        maximizeEvent: maximizeEvent,
        setLoginToken: setLoginToken,
        checkLoginToken: checkLoginToken,
        getMitarbeiter: getMitarbeiter,
        getGroupsForEvent: getGroupsForEvent,
        removePosition: removePosition,
        getEingesetztAls: getEingesetztAls,
        updatePassword: updatePassword,
        updateEmail: updateEmail,
        getMitarbeiterDetails: getMitarbeiterDetails,
        sendPasswordResetEmail: sendPasswordResetEmail,
        resetPassword: resetPassword,
        getPartner: getPartner,
        getAllSpecialFields: getAllSpecialFields,
        getArbeit: getArbeit,
        updateArbeit: updateArbeit,
        checkCaptcha: checkCaptcha,
        getPositionenForEvent: getPositionenForEvent,
        getEmailAdresses: getEmailAdresses,
        sendMassEmail: sendMassEmail,
        getGroupsForUser: getGroupsForUser,
        getGastLink: getGastLink,
        updatePartner: updatePartner,
        getStatistics: getStatistics,
        getMitarbeiterForEvent: getMitarbeiterForEvent,
        generateEmailList: generateEmailList,
        getMitarbeiterForEventDetailed: getMitarbeiterForEventDetailed,
        presenceStatusChanged: presenceStatusChanged,
        returnDonationBox: returnDonationBox,
        borrowDonationBox: borrowDonationBox,
        getMyLevelAndPoints: getMyLevelAndPoints,
        getPassportDetails: getPassportDetails,
        deleteMe: deleteMe,
        resendApproveEmail: resendApproveEmail,
        registerMonitor: registerMonitor,
        unRegisterMonitor: unRegisterMonitor,
        getMonitorData: getMonitorData,
        callOperation: callOperation
    };

}]);
